import React from "react";
import {cx} from "../../lib/ClassSet";
import {formatSubscriptionStatus} from "../../lib/SubscriptionStatus";
import "./SubscriptionItem.css";
import format from 'date-fns/format'

const SubscriptionItem = (props) => {

  let {data} = props;

  let subscribedAt = format(data.get("subscribedAt"), "MMM D, YYYY");

  let classes = cx({
    "item": true,
    "subscription-list-item": true,
    "u-selected": props.selected
  })

  let idClickFn = (e) => {
    props.onClick(data, e, "id")
  }

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-id"><span onClick={idClickFn}>{data.get("subscriptionId")}</span></td>
      <td className="field f-integer">{data.get("currentSeqId")}</td>
      <td className="field f-date">{subscribedAt}</td>
      <td className="field f-name">{data.get("name")}</td>
      <td className="field f-recipient">{data.getIn(["shippingAddress", "name"])}</td>
      <td className="field f-destination">{data.getIn(["shippingAddress", "addressCity"])}, {data.getIn(["shippingAddress", "addressStateProvince"])}, {data.getIn(["shippingAddress", "addressCountryCode"])}</td>
      <td className="field">{data.get("frequencyWeeks")}</td>
      <td className="field f-qty">{get_quantity(data.get("products"))}</td>
      <td className="field f-status">{formatSubscriptionStatus(data)}</td>
    </tr>
  )
}

function get_quantity(products) {
  return products.reduce((acc, product) => {
    return acc + product.get("quantity");
  }, 0)
}

export default SubscriptionItem;